module.exports = __webpack_public_path__ + "static/media/arrow-right-team.0eb8f27b.svg";